<header class="fixed z-[9] w-full">
	<nav id="navbar" class="bg-white border-gray-200 shadow">
		<div class="flex flex-wrap items-center justify-between p-4 mx-auto transition-all container-nav">
			<a routerLink="/" class="flex items-center space-x-3 rtl:space-x-reverse">
				<img id="logo" src="images/logo.png" class="h-8" alt="Movil Bus logo" />
			</a>
			<div id="mega-menu-full" class="space-x-6">
				<ul *ngIf="menuPrincipal && menuPrincipal[0]?.items">
					@for (item of menuPrincipal[0].items; track $index) { @if(item.nueva_ventana){
					<li>
						<a target="_blank" [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
					</li>
					}@else {
					<li routerLinkActive="active">
						<a [routerLink]="item.url_personalizada || item.url">{{ item.nombre }}</a>
					</li>
					} }
				</ul>
				<div class="flex items-center space-x-4" id="info_extra">
					<app-separator class="separador" />
					<div class="flex items-center space-x-2">
						<div id="icono_wsp_tel">
							<img src="./images/telefono.svg" width="30" height="30" />
						</div>
						<div class="headertelefono">
							<a href="tel:5117168000" target="_blank">01-7168000</a>
						</div>
					</div>
					<app-separator class="separador" />
					@if (!isOpen) {
					<button
						(click)="toggleOffcanvas()"
						data-collapse-toggle="navbar-hamburger"
						type="button"
						class="inline-flex items-center justify-center w-10 h-10 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
						aria-controls="navbar-hamburger"
						aria-expanded="false"
						aria-haspopup="dialog"
						aria-expanded="false"
						aria-controls="hs-offcanvas-right"
						data-hs-overlay="#hs-offcanvas-right"
					>
						<span class="sr-only">Open main menu</span>
						<svg id="burger" xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24">
							<rect id="Rectángulo_4" data-name="Rectángulo 4" width="35" height="4" fill="#ec6726" />
							<rect
								id="Rectángulo_5"
								data-name="Rectángulo 5"
								width="35"
								height="4"
								transform="translate(0 10)"
								fill="#ec6726"
							/>
							<rect
								id="Rectángulo_6"
								data-name="Rectángulo 6"
								width="35"
								height="4"
								transform="translate(0 20)"
								fill="#ec6726"
							/>
						</svg>
					</button>
					}@else {
					<button
						type="button"
						class="inline-flex items-center justify-center w-10 h-10 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
						aria-label="Close"
						data-hs-overlay="#hs-offcanvas-right"
						(click)="toggleOffcanvas()"
					>
						<span class="sr-only">Close</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="27.956" height="28.687" viewBox="0 0 27.956 28.687">
							<g id="burger" transform="translate(0.931 4.343)">
								<rect
									id="Rectángulo_4"
									data-name="Rectángulo 4"
									width="35"
									height="4"
									transform="matrix(0.719, 0.695, -0.695, 0.719, 1.848, -3.596)"
									fill="#ec6726"
								/>
								<rect
									id="Rectángulo_6"
									data-name="Rectángulo 6"
									width="35"
									height="4"
									transform="translate(-0.93 21.667) rotate(-48)"
									fill="#ec6726"
								/>
							</g>
						</svg>
					</button>
					}
				</div>
			</div>
		</div>
	</nav>
</header>
